import { startTransition, useEffect } from 'react';

import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import useClientState from '@/state/useClientState';
import { useQuery } from '@tanstack/react-query';

import { WtsGetResponse } from './WtsTypes';

export default function useGetWtsEenheden() {
  const setWtsEenheden = useClientState((state) => state.setWtsEenheden);
  const { fetchWithAuth } = useFetchWithAuth();
  const fetcher = async (): Promise<WtsGetResponse> => {
    const response = await fetchWithAuth('/eenheid/v1/wtsUitsluiting');
    if (response.ok) return response.json();
    return [];
  };
  const { data } = useQuery({
    queryKey: ['wtsUitgesloten'],
    queryFn: fetcher,
    refetchInterval: 10_000,
  });

  useEffect(() => {
    if (data)
      startTransition(() => {
        setWtsEenheden(data);
      });
  }, [data]);
}
